import { useTranslation } from 'react-i18next'

import PerksProductClassDetails from 'adminDashboard/benefitDetails/common/productClassDetails/perksProductClassDetails'

//
import getBenefitProductClasses, {
  BenefitProductClassResponse,
} from 'core/application/adminDashboard/benefitDetails/getBenefitProductClasses'
import { BenefitDetails } from 'core/application/csiDashboard/csiSearch/getBenefitDetails'

//
import { Col, Skeleton } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'
import { useQueryRequestV2 } from 'common/hooks'

import EarlyRunoutDetails from '../../../common/programDetails/earlyRunout'
import BenefitInfoCard from '../../../qsehra/programDetails/benefitDetails/BenefitInfoCard'

interface CsiPerksBenefitDetailsProps {
  planPeriodId: string
  benefitDetails?: BenefitDetails
  refreshBenefitDetails: () => Promise<void>
}

const CsiPerksBenefitDetails: React.FC<CsiPerksBenefitDetailsProps> = (props) => {
  const { t: translate } = useTranslation()
  const { data: productClasses, isLoading: areProductClassesLoading } = useQueryRequestV2<
    BenefitProductClassResponse[]
  >({
    queryFn: () => {
      return getBenefitProductClasses(props.planPeriodId)
    },
  })
  return (
    <>
      <div className="mb-24">
        <EarlyRunoutDetails benefitDetails={props.benefitDetails} refreshBenefitDetails={props.refreshBenefitDetails} />
      </div>
      {!props.benefitDetails.allowToTriggeringEarlyRunout && (
        <div className="mt-16">
          <BenefitInfoCard
            title={translate('csi-dashboard.program-details.benefit-end-date-title')}
            description={parseZoneFormat(props.benefitDetails.endDate)}
            completed={true}
            translate={translate}
          />
        </div>
      )}
      {!props.benefitDetails.allowToTriggeringEarlyRunout && (
        <div className="mt-16">
          <BenefitInfoCard
            title={translate('csi-dashboard.program-details.trigger-early-runout.early-run-out-days')}
            description={props.benefitDetails.runOutDays}
            completed={true}
            translate={translate}
          />
        </div>
      )}
      <Skeleton loading={areProductClassesLoading}>
        {productClasses?.map((item, index) => (
          <Col span={24}>
            <PerksProductClassDetails
              key={item.id}
              collapseKey={index}
              item={item}
              colSpan={24}
              planPeriodId={props.planPeriodId}
              displayActionColumn={true}
            />
          </Col>
        ))}
      </Skeleton>
    </>
  )
}

export default CsiPerksBenefitDetails
